// import React, { useState, useEffect } from "react";
// import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
// import { StyledTypography } from "components/StyledComponents/styledComponents.js";
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableRow,
//   Paper,
//   Grid,
//   TextField,
//   Typography,
//   Box,
//   Tooltip,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   CircularProgress,
// } from "@mui/material";
// import EditIcon from "@mui/icons-material/Edit";
// import Autocomplete from "@mui/material/Autocomplete";
// import {
//   StyledButton,
//   StyledAlert,
//   StyledSnackbar,
//   inputStyle,
//   ViewButton,
//   DeleteButton,
//   StyledTableContainer,
//   StyledButtonC,
//   CustomTableCell,
// } from "components/StyledComponents/styledComponents.js";
// import RestartAltIcon from "@mui/icons-material/RestartAlt";
// import { CustomPaper } from "components/Styles/globalStyles";
// import Cookie from "js-cookie";
// import { useNavigate } from "react-router-dom";
// import URLs from "constants/urls";
// import AddTaskIcon from "@mui/icons-material/AddTask";
// import DeleteIcon from "@mui/icons-material/Delete";
// import { useMaterialUIController } from "context";

// export default function PayStructureConfiguration() {
//   const [controller] = useMaterialUIController(); // Get context state
//   const { user } = controller; // Destructure user
//   const [companyCode, setCompanyCode] = useState("");
//   const [structureType, setStructureType] = useState("");
//   const [structureName, setStructureName] = useState("");
//   const [dropdownValue, setDropdownValue] = useState("");
//   const [value, setValue] = useState("");
//   const [structureData, setStructureData] = useState([]);
//   const [open, setOpen] = useState(false);
//   const [message, setMessage] = useState("");
//   const [alertType, setAlertType] = useState("success");
//   const [loading, setLoading] = useState(true);
//   const [selectedPayId, setSelectedPayId] = useState("");
//   const [payStructId, setPayStructId] = useState();
//   const [editMode, setEditMode] = useState(false);
//   const hrms_token = Cookie.get("hrms_token");
//   const payOptions = [
//     { payName: "Gross Pay", payId: "GrossPay" },
//     { payName: "Basic Pay", payId: "BasicPay" },
//   ];
//   const resetForm = () => {
//     setStructureType("");
//     setStructureName("");
//     setDropdownValue("");
//     setValue("");
//     setSelectedPayId("");
//     setEditMode(false);
//   };
//   const jwt_token = Cookie.get("jwt_token");
//   const MInput = inputStyle();
//   const structureTypeOptions = [
//     { label: "ADDITION", value: "ADDITION" },
//     { label: "DEDUCTION", value: "DEDUCTION" },
//   ];
//   const dropdownOptions = [
//     { label: "FIXED", value: "FIXED" },
//     { label: "PERCENT", value: "PERCENT" },
//   ];

//   const setAlert = (msg, type) => {
//     setMessage(msg);
//     setAlertType(type);
//     setOpen(true);
//   };

//   const handleClose = () => {
//     setOpen(false);
//   };

//   const resetStructInputFields = () => {
//     setStructureType("");
//     setStructureName("");
//     setDropdownValue("");
//     setSelectedPayId("");
//     setValue("");
//   };

//   const handleAddStructure = async () => {
//     if (!structureType || !structureName || !dropdownValue || !value || !selectedPayId) {
//       setAlert("Please fill in all fields", "error");
//       return;
//     }

//     const newStructure = {
//       payStructId: editMode ? payStructId : 0,
//       companyId: user.companyId,
//       structName: structureName,
//       structType: structureType,
//       appliedOn: selectedPayId,
//       structPercentFixedType: dropdownValue,
//       structValue: parseFloat(value),
//     };

//     console.log("lfkfkfkfkfkfkfkf", newStructure);

//     const url = editMode ? `${URLs.hrmsPayStructure}/${payStructId}` : URLs.hrmsPayStructDetails;

//     const options = {
//       method: editMode ? "PUT" : "POST",
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${hrms_token}`,
//       },
//       body: JSON.stringify(newStructure),
//     };

//     setLoading(true);
//     try {
//       const response = await fetch(url, options);
//       const data = await response.json();

//       if (!response.ok) {
//         throw new Error(data.message || `HTTP error! Status: ${response.status}`);
//       }

//       setAlert(editMode ? "Structure updated successfully" : data.message, "success");
//       fetchPayStructureData();
//       resetStructInputFields();
//       setEditMode(false);
//     } catch (error) {
//       console.error("Error occurred:", error);
//       setAlert(error.message || "An unknown error occurred", "error");
//     } finally {
//       setLoading(false);
//     }
//   };
//   useEffect(() => {
//     fetchPayStructureData();
//   }, []);

//   const handleDeleteStructure = async (index) => {
//     const payStructId = structureData[index]?.payStructId; // Get the ID

//     if (!payStructId) {
//       setAlert("Invalid Structure ID", "error");
//       return;
//     }

//     const url = `${URLs.hrmsPayStructure}/${payStructId}`;

//     const options = {
//       method: "DELETE",
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${hrms_token}`,
//       },
//     };
//     setLoading(true);
//     try {
//       const response = await fetch(url, options);

//       if (!response.ok) {
//         throw new Error(`HTTP error! Status: ${response.status}`);
//       }

//       setAlert("Structure deleted successfully", "success");
//       fetchPayStructureData();
//     } catch (error) {
//       setAlert("Failed to delete structure", "error");
//     }
//     setLoading(false);
//   };

//   const fetchPayStructureData = async () => {
//     const url = `${URLs.hrmsPayStructsByCid}/${user.companyId}`;

//     const options = {
//       method: "GET",
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${hrms_token}`,
//       },
//     };

//     setLoading(true);
//     try {
//       const response = await fetch(url, options);

//       if (!response.ok) {
//         throw new Error(`HTTP error! Status: ${response.status}`);
//       }

//       const data = await response.json();
//       const sortedData = data.sort((a, b) => a.structType.localeCompare(b.structType));
//       setStructureData(sortedData);
//     } catch (error) {
//       setAlert("Failed to fetch Pay Structure data", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleEditStructure = async (index) => {
//     const newStructure = structureData[index];
//     console.log("kfjfjfjfjf", newStructure);
//     setEditMode(true);
//     setStructureName(newStructure.structName);
//     setDropdownValue(newStructure.structPercentFixedType.trim());
//     setValue(newStructure.structValue);
//     setStructureType(newStructure.structType);
//     setSelectedPayId(newStructure.appliedOn.trim());
//     setPayStructId(newStructure.payStructId);
//   };

//   return (
//     <DashboardLayout>
//       <Dialog
//         open={loading}
//         onClose={() => setLoading(false)}
//         aria-labelledby="loading-dialog-title"
//       >
//         <DialogContent style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
//           <CircularProgress color="primary" />
//           <Typography variant="h6" style={{ marginTop: "20px" }}>
//             Loading, please wait...
//           </Typography>
//         </DialogContent>
//       </Dialog>
//       <StyledSnackbar
//         open={open}
//         autoHideDuration={5000}
//         onClose={handleClose}
//         anchorOrigin={{ vertical: "top", horizontal: "center" }}
//         severity={alertType}
//       >
//         <StyledAlert onClose={handleClose} severity={alertType}>
//           {message}
//         </StyledAlert>
//       </StyledSnackbar>
//       <StyledTableContainer
//         container
//         spacing={1}
//         sx={{
//           display: "flex",
//           backgroundColor: "#ffffff",
//           minHeight: "500px", // Ensure enough height
//           borderRadius: "15px",
//           overflow: "auto", // Enables scrolling if content overflows
//           width: "100%", // Ensures responsiveness
//         }}
//       >
//         <Grid
//           container
//           spacing={1}
//           sx={{
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             width: "100%",
//             margin: "auto",
//           }}
//         >
//           <Grid item xs={12} md={12} lg={10} p={1} mt={{ xs: 2, md: 5, lg: 5 }}>
//             <TableContainer
//               component={Paper}
//               sx={{
//                 boxShadow: "none",
//                 maxWidth: "100%", // Prevents cutoff
//                 overflowX: "auto", // Enables horizontal scrolling
//               }}
//             >
//               <div style={{ position: "relative", width: "100%" }}>
//                 <StyledTypography>Pay Structure Configuration</StyledTypography>
//                 <Tooltip title="Reset">
//                   <StyledButtonC onClick={resetForm}>
//                     <RestartAltIcon />
//                   </StyledButtonC>
//                 </Tooltip>
//               </div>
//               <Grid>
//                 <form onSubmit={(e) => e.preventDefault()}>
//                   <Grid container spacing={2} p={2}>
//                     <TableContainer sx={{ width: "100%", overflowX: "auto", mt: 2 }}>
//                       <Table
//                         sx={{
//                           border: "1px solid #ddd",
//                           borderRadius: "8px",
//                           minWidth: "900px",
//                           tableLayout: "fixed",
//                         }}
//                       >
//                         <TableBody>
//                           <TableRow>
//                             {[
//                               "Select Structure Type",
//                               "Structure Name",
//                               "Select Type",
//                               "Applied On",
//                               "Value",
//                               "Action",
//                             ].map((header, index) => (
//                               <CustomTableCell
//                                 key={index}
//                                 sx={{
//                                   minWidth: index === 0 ? 200 : 100,
//                                   fontWeight: "bold",
//                                   backgroundColor: "#f8f8f8",
//                                   padding: "8px",
//                                   position: index === 4 ? "sticky" : "static", // Fix last column
//                                   right: index === 4 ? 0 : "auto", // Fix position on the right
//                                   background: "#f8f8f8", // Ensure background for sticky column
//                                   zIndex: index === 4 ? 2 : 1,
//                                 }}
//                               >
//                                 {header}
//                               </CustomTableCell>
//                             ))}
//                           </TableRow>

//                           <TableRow>
//                             <TableCell>
//                               <Autocomplete
//                                 options={structureTypeOptions}
//                                 getOptionLabel={(option) => option.label}
//                                 value={
//                                   structureTypeOptions.find(
//                                     (option) => option.value === structureType
//                                   ) || null
//                                 }
//                                 onChange={(event, value) =>
//                                   setStructureType(value ? value.value : "")
//                                 }
//                                 fullWidth
//                                 PaperComponent={CustomPaper}
//                                 renderInput={(params) => (
//                                   <TextField
//                                     {...params}
//                                     label=""
//                                     required
//                                     sx={{
//                                       height: 43,
//                                       ...MInput.b,
//                                       "& .MuiInputBase-root": {
//                                         height: "100%",
//                                       },
//                                     }}
//                                     InputLabelProps={{
//                                       sx: {
//                                         color: MInput.a,
//                                         "&.Mui-focused": {
//                                           color: "red",
//                                         },
//                                       },
//                                     }}
//                                   />
//                                 )}
//                               />
//                             </TableCell>
//                             <TableCell>
//                               <TextField
//                                 label=""
//                                 value={structureName}
//                                 onChange={(e) => setStructureName(e.target.value)}
//                                 fullWidth
//                                 required
//                                 sx={MInput.b}
//                                 InputLabelProps={{
//                                   sx: { color: MInput.a },
//                                 }}
//                               />
//                             </TableCell>
//                             <TableCell>
//                               <Autocomplete
//                                 options={dropdownOptions}
//                                 getOptionLabel={(option) => option.label}
//                                 value={
//                                   dropdownOptions.find(
//                                     (option) => option.value === dropdownValue
//                                   ) || null
//                                 }
//                                 onChange={(event, value) =>
//                                   setDropdownValue(value ? value.value : "")
//                                 }
//                                 fullWidth
//                                 PaperComponent={CustomPaper}
//                                 renderInput={(params) => (
//                                   <TextField
//                                     {...params}
//                                     label=""
//                                     required
//                                     sx={{
//                                       height: 43,
//                                       ...MInput.b,
//                                       "& .MuiInputBase-root": {
//                                         height: "100%",
//                                       },
//                                     }}
//                                     InputLabelProps={{
//                                       sx: {
//                                         color: MInput.a,
//                                         "&.Mui-focused": {
//                                           color: "red",
//                                         },
//                                       },
//                                     }}
//                                   />
//                                 )}
//                               />
//                             </TableCell>
//                             <TableCell>
//                               <Autocomplete
//                                 options={payOptions} // Array of pay structures
//                                 getOptionLabel={(option) => option.payName} // Display payName in dropdown
//                                 value={
//                                   payOptions.find((option) => option.payId === selectedPayId) ||
//                                   null
//                                 }
//                                 onChange={(event, value) =>
//                                   setSelectedPayId(value ? value.payId : "")
//                                 }
//                                 fullWidth
//                                 PaperComponent={CustomPaper}
//                                 renderInput={(params) => (
//                                   <TextField
//                                     {...params}
//                                     label=""
//                                     required
//                                     sx={{
//                                       height: 43,
//                                       ...MInput.b,
//                                       "& .MuiInputBase-root": {
//                                         height: "100%",
//                                       },
//                                     }}
//                                     InputLabelProps={{
//                                       sx: {
//                                         color: MInput.a,
//                                         "&.Mui-focused": {
//                                           color: "red",
//                                         },
//                                       },
//                                     }}
//                                   />
//                                 )}
//                               />
//                             </TableCell>
//                             <TableCell>
//                               <TextField
//                                 label=""
//                                 value={value}
//                                 onChange={(e) => setValue(e.target.value)}
//                                 fullWidth
//                                 required
//                                 type="number"
//                                 inputProps={{ min: 0 }}
//                                 sx={MInput.b}
//                                 InputLabelProps={{
//                                   sx: { color: MInput.a },
//                                 }}
//                               />
//                             </TableCell>
//                             <TableCell
//                               sx={{
//                                 position: "sticky",
//                                 right: 0,
//                                 background: "#f8f8f8",
//                                 zIndex: 2,
//                               }}
//                             >
//                               <ViewButton
//                                 type="button"
//                                 onClick={handleAddStructure}
//                                 sx={{ minWidth: "40px" }}
//                               >
//                                 <AddTaskIcon />
//                               </ViewButton>
//                             </TableCell>
//                           </TableRow>
//                         </TableBody>
//                       </Table>
//                     </TableContainer>

//                     <TableContainer
//                       sx={{
//                         mt: 2,
//                         width: "100%",
//                         overflow: "auto",
//                         height: "30vw",
//                         minHeight: "150px",
//                         maxHeight: "250px",
//                         flexGrow: 1,
//                       }}
//                     >
//                       <Table
//                         sx={{
//                           border: "1px solid #ddd",
//                           borderRadius: "8px",
//                           minWidth: "900px",
//                           tableLayout: "fixed",
//                         }}
//                       >
//                         <TableBody>
//                           <TableRow
//                             sx={{
//                               backgroundColor: "#f0f0f0",
//                             }}
//                           >
//                             {[
//                               "Select Structure Type",
//                               "Structure Name",
//                               "Percent/Fixed",
//                               "Applied On",
//                               "Value",
//                               "Action",
//                             ].map((header, index) => (
//                               <CustomTableCell
//                                 key={index}
//                                 sx={{
//                                   minWidth: index === 0 ? 200 : 100,
//                                   fontWeight: "bold",
//                                   backgroundColor: "#f8f8f8",
//                                   padding: "8px",
//                                   position: index === 4 ? "sticky" : "static", // Fix last column
//                                   right: index === 4 ? 0 : "auto", // Fix position on the right
//                                   background: "#f8f8f8", // Ensure background for sticky column
//                                   zIndex: index === 4 ? 2 : 1,
//                                 }}
//                               >
//                                 {header}
//                               </CustomTableCell>
//                             ))}
//                           </TableRow>
//                           {structureData.length > 0 ? (
//                             structureData.map((item, index) => (
//                               <TableRow key={index}>
//                                 <CustomTableCell sx={{ minWidth: 200 }}>
//                                   {item.structType}
//                                 </CustomTableCell>
//                                 <CustomTableCell sx={{ minWidth: 200 }}>
//                                   {item.structName}
//                                 </CustomTableCell>
//                                 <CustomTableCell sx={{ minWidth: 200 }}>
//                                   {item.structPercentFixedType}
//                                 </CustomTableCell>
//                                 <CustomTableCell sx={{ minWidth: 200 }}>
//                                   {item.appliedOn}
//                                 </CustomTableCell>
//                                 <CustomTableCell sx={{ minWidth: 200 }}>
//                                   {item.structValue}
//                                 </CustomTableCell>
//                                 <CustomTableCell
//                                   sx={{
//                                     minWidth: 150,
//                                     position: "sticky",
//                                     right: 0,
//                                     backgroundColor: "#f8f8f8",
//                                     zIndex: 2,
//                                   }}
//                                 >
//                                   <ViewButton
//                                     type="button"
//                                     onClick={() => handleEditStructure(index)}
//                                   >
//                                     <EditIcon />
//                                   </ViewButton>
//                                   <DeleteButton
//                                     type="button"
//                                     onClick={() => handleDeleteStructure(index)}
//                                   >
//                                     <DeleteIcon />
//                                   </DeleteButton>
//                                 </CustomTableCell>
//                               </TableRow>
//                             ))
//                           ) : (
//                             <TableRow>
//                               <CustomTableCell
//                                 colSpan={5}
//                                 align="center"
//                                 sx={{ padding: "10px", fontWeight: "500" }}
//                               >
//                                 No data available
//                               </CustomTableCell>
//                             </TableRow>
//                           )}
//                         </TableBody>
//                       </Table>
//                     </TableContainer>
//                   </Grid>
//                 </form>
//               </Grid>
//             </TableContainer>
//           </Grid>
//         </Grid>
//       </StyledTableContainer>

//       <StyledSnackbar
//         open={open}
//         autoHideDuration={5000}
//         onClose={handleClose}
//         anchorOrigin={{ vertical: "top", horizontal: "center" }}
//       >
//         <StyledAlert onClose={handleClose} severity={alertType}>
//           {message}
//         </StyledAlert>
//       </StyledSnackbar>
//     </DashboardLayout>
//   );
// }
import React, { useState, useEffect } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { StyledTypography } from "components/StyledComponents/styledComponents.js";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Grid,
  TextField,
  Typography,
  Box,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  CircularProgress,
  FormControl,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import Autocomplete from "@mui/material/Autocomplete";
import {
  StyledButton,
  StyledAlert,
  StyledSnackbar,
  inputStyle,
  ViewButton,
  DeleteButton,
  StyledTableContainer,
  StyledButtonC,
  CustomTableCell,
} from "components/StyledComponents/styledComponents.js";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { CustomPaper } from "components/Styles/globalStyles";
import Cookie from "js-cookie";
import { useNavigate } from "react-router-dom";
import URLs from "constants/urls";
import AddTaskIcon from "@mui/icons-material/AddTask";
import DeleteIcon from "@mui/icons-material/Delete";
import { useMaterialUIController } from "context";

export default function PayStructureConfiguration() {
  const [controller] = useMaterialUIController(); // Get context state
  const { user } = controller; // Destructure user
  const [companyCode, setCompanyCode] = useState("");
  const [structureType, setStructureType] = useState("");
  const [structureName, setStructureName] = useState("");
  const [dropdownValue, setDropdownValue] = useState("");
  const [value, setValue] = useState("");
  const [structureData, setStructureData] = useState([]);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [alertType, setAlertType] = useState("success");
  const [loading, setLoading] = useState(true);
  const [selectedPayId, setSelectedPayId] = useState("");
  const [payStructId, setPayStructId] = useState();
  const [editMode, setEditMode] = useState(false);
  const [deductFromSalary, setDeductFromSalary] = useState(false);
  const [componentCategory, setComponentCategory] = useState("");
  const hrms_token = Cookie.get("hrms_token");

  const payOptions = [
    { payName: "Gross Pay", payId: "GrossPay" },
    { payName: "Basic Pay", payId: "BasicPay" },
  ];

  const resetForm = () => {
    setStructureType("");
    setStructureName("");
    setDropdownValue("");
    setValue("");
    setSelectedPayId("");
    setEditMode(false);
    setDeductFromSalary(false);
    setComponentCategory("");
  };

  const jwt_token = Cookie.get("jwt_token");
  const MInput = inputStyle();

  const structureTypeOptions = [
    { label: "ADDITION", value: "ADDITION" },
    { label: "DEDUCTION", value: "DEDUCTION" },
  ];

  const dropdownOptions = [
    { label: "FIXED", value: "FIXED" },
    { label: "PERCENT", value: "PERCENT" },
  ];

  const componentCategoryOptions = [
    { label: "EARNINGS", value: "EARNINGS" },
    { label: "EMPLOYER_CONTRIBUTION", value: "EMPLOYER_CONTRIBUTION" },
    { label: "EMPLOYEE_DEDUCTION", value: "EMPLOYEE_DEDUCTION" },
  ];

  const setAlert = (msg, type) => {
    setMessage(msg);
    setAlertType(type);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const resetStructInputFields = () => {
    setStructureType("");
    setStructureName("");
    setDropdownValue("");
    setSelectedPayId("");
    setValue("");
    setDeductFromSalary(false);
    setComponentCategory("");
  };

  const handleAddStructure = async () => {
    if (
      !structureType ||
      !structureName ||
      !dropdownValue ||
      !value ||
      !selectedPayId ||
      !componentCategory
    ) {
      setAlert("Please fill in all fields", "error");
      return;
    }

    const newStructure = {
      payStructId: editMode ? payStructId : 0,
      companyId: user.companyId,
      structName: structureName,
      structType: structureType,
      appliedOn: selectedPayId,
      structPercentFixedType: dropdownValue,
      structValue: parseFloat(value),
      deductFromSalary: deductFromSalary ? "Y" : "N",
      componentCategory: componentCategory,
    };

    console.log("Payload:", newStructure);

    const url = editMode ? `${URLs.hrmsPayStructure}/${payStructId}` : URLs.hrmsPayStructDetails;

    const options = {
      method: editMode ? "PUT" : "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${hrms_token}`,
      },
      body: JSON.stringify(newStructure),
    };

    setLoading(true);
    try {
      const response = await fetch(url, options);
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || `HTTP error! Status: ${response.status}`);
      }

      setAlert(editMode ? "Structure updated successfully" : data.message, "success");
      fetchPayStructureData();
      resetStructInputFields();
      setEditMode(false);
    } catch (error) {
      console.error("Error occurred:", error);
      setAlert(error.message || "An unknown error occurred", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPayStructureData();
  }, []);

  const handleDeleteStructure = async (index) => {
    const payStructId = structureData[index]?.payStructId; // Get the ID

    if (!payStructId) {
      setAlert("Invalid Structure ID", "error");
      return;
    }

    const url = `${URLs.hrmsPayStructure}/${payStructId}`;

    const options = {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${hrms_token}`,
      },
    };
    setLoading(true);
    try {
      const response = await fetch(url, options);

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      setAlert("Structure deleted successfully", "success");
      fetchPayStructureData();
    } catch (error) {
      setAlert("Failed to delete structure", "error");
    }
    setLoading(false);
  };

  const fetchPayStructureData = async () => {
    const url = `${URLs.hrmsPayStructsByCid}/${user.companyId}`;

    const options = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${hrms_token}`,
      },
    };

    setLoading(true);
    try {
      const response = await fetch(url, options);

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      const sortedData = data.sort((a, b) => a.structType.localeCompare(b.structType));
      setStructureData(sortedData);
    } catch (error) {
      setAlert("Failed to fetch Pay Structure data", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleEditStructure = async (index) => {
    const newStructure = structureData[index];
    console.log("Edit Structure:", newStructure);
    setEditMode(true);
    setStructureName(newStructure.structName);
    setDropdownValue(newStructure.structPercentFixedType.trim());
    setValue(newStructure.structValue);
    setStructureType(newStructure.structType);
    setSelectedPayId(newStructure.appliedOn.trim());
    setPayStructId(newStructure.payStructId);
    setDeductFromSalary(newStructure.deductFromSalary === "Y");
    setComponentCategory(newStructure.componentCategory);
  };

  return (
    <DashboardLayout>
      <Dialog
        open={loading}
        onClose={() => setLoading(false)}
        aria-labelledby="loading-dialog-title"
      >
        <DialogContent style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <CircularProgress color="primary" />
          <Typography variant="h6" style={{ marginTop: "20px" }}>
            Loading, please wait...
          </Typography>
        </DialogContent>
      </Dialog>
      <StyledSnackbar
        open={open}
        autoHideDuration={5000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        severity={alertType}
      >
        <StyledAlert onClose={handleClose} severity={alertType}>
          {message}
        </StyledAlert>
      </StyledSnackbar>
      <StyledTableContainer
        container
        spacing={1}
        sx={{
          display: "flex",
          backgroundColor: "#ffffff",
          minHeight: "500px", // Ensure enough height
          borderRadius: "15px",
          overflow: "auto", // Enables scrolling if content overflows
          width: "100%", // Ensures responsiveness
        }}
      >
        <Grid
          container
          spacing={1}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            margin: "auto",
          }}
        >
          <Grid item xs={12} md={12} lg={11} p={1} mt={{ xs: 2, md: 5, lg: 5 }}>
            <TableContainer
              component={Paper}
              sx={{
                boxShadow: "none",
                maxWidth: "100%", // Prevents cutoff
                overflowX: "auto", // Enables horizontal scrolling
              }}
            >
              <div style={{ position: "relative", width: "100%" }}>
                <StyledTypography>Pay Structure Configuration</StyledTypography>
                <Tooltip title="Reset">
                  <StyledButtonC onClick={resetForm}>
                    <RestartAltIcon />
                  </StyledButtonC>
                </Tooltip>
              </div>
              <Grid>
                <form onSubmit={(e) => e.preventDefault()}>
                  <Grid container spacing={2} p={2}>
                    <TableContainer sx={{ width: "100%", overflowX: "auto", mt: 2 }}>
                      <Table
                        sx={{
                          border: "1px solid #ddd",
                          borderRadius: "8px",
                          minWidth: "1100px", // Increased width for new columns
                          tableLayout: "fixed",
                        }}
                      >
                        <TableBody>
                          <TableRow>
                            {[
                              "Select Structure Type",
                              "Structure Name",
                              "Select Type",
                              "Applied On",
                              "Value",
                              "Deduct From Salary",
                              "Component Category",
                              "Action",
                            ].map((header, index) => (
                              <CustomTableCell
                                key={index}
                                sx={{
                                  minWidth: index === 0 ? 200 : 80,
                                  fontWeight: "bold",
                                  backgroundColor: "#f8f8f8",
                                  padding: "8px",
                                  position: index === 6 ? "sticky" : "static", // Fix last column
                                  right: index === 6 ? 0 : "auto", // Fix position on the right
                                  background: "#f8f8f8", // Ensure background for sticky column
                                  zIndex: index === 6 ? 2 : 1,
                                }}
                              >
                                {header}
                              </CustomTableCell>
                            ))}
                          </TableRow>

                          <TableRow>
                            <TableCell>
                              <Autocomplete
                                options={structureTypeOptions}
                                getOptionLabel={(option) => option.label}
                                value={
                                  structureTypeOptions.find(
                                    (option) => option.value === structureType
                                  ) || null
                                }
                                onChange={(event, value) =>
                                  setStructureType(value ? value.value : "")
                                }
                                fullWidth
                                PaperComponent={CustomPaper}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label=""
                                    required
                                    sx={{
                                      height: 43,
                                      ...MInput.b,
                                      "& .MuiInputBase-root": {
                                        height: "100%",
                                      },
                                    }}
                                    InputLabelProps={{
                                      sx: {
                                        color: MInput.a,
                                        "&.Mui-focused": {
                                          color: "red",
                                        },
                                      },
                                    }}
                                  />
                                )}
                              />
                            </TableCell>
                            <TableCell>
                              <TextField
                                label=""
                                value={structureName}
                                onChange={(e) => setStructureName(e.target.value)}
                                fullWidth
                                required
                                sx={MInput.b}
                                InputLabelProps={{
                                  sx: { color: MInput.a },
                                }}
                              />
                            </TableCell>
                            <TableCell>
                              <Autocomplete
                                options={dropdownOptions}
                                getOptionLabel={(option) => option.label}
                                value={
                                  dropdownOptions.find(
                                    (option) => option.value === dropdownValue
                                  ) || null
                                }
                                onChange={(event, value) =>
                                  setDropdownValue(value ? value.value : "")
                                }
                                fullWidth
                                PaperComponent={CustomPaper}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label=""
                                    required
                                    sx={{
                                      height: 43,
                                      ...MInput.b,
                                      "& .MuiInputBase-root": {
                                        height: "100%",
                                      },
                                    }}
                                    InputLabelProps={{
                                      sx: {
                                        color: MInput.a,
                                        "&.Mui-focused": {
                                          color: "red",
                                        },
                                      },
                                    }}
                                  />
                                )}
                              />
                            </TableCell>
                            <TableCell>
                              <Autocomplete
                                options={payOptions} // Array of pay structures
                                getOptionLabel={(option) => option.payName} // Display payName in dropdown
                                value={
                                  payOptions.find((option) => option.payId === selectedPayId) ||
                                  null
                                }
                                onChange={(event, value) =>
                                  setSelectedPayId(value ? value.payId : "")
                                }
                                fullWidth
                                PaperComponent={CustomPaper}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label=""
                                    required
                                    sx={{
                                      height: 43,
                                      ...MInput.b,
                                      "& .MuiInputBase-root": {
                                        height: "100%",
                                      },
                                    }}
                                    InputLabelProps={{
                                      sx: {
                                        color: MInput.a,
                                        "&.Mui-focused": {
                                          color: "red",
                                        },
                                      },
                                    }}
                                  />
                                )}
                              />
                            </TableCell>
                            <TableCell>
                              <TextField
                                label=""
                                value={value}
                                onChange={(e) => setValue(e.target.value)}
                                fullWidth
                                required
                                type="number"
                                inputProps={{ min: 0 }}
                                sx={MInput.b}
                                InputLabelProps={{
                                  sx: { color: MInput.a },
                                }}
                              />
                            </TableCell>
                            <TableCell>
                              <FormControl fullWidth>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={deductFromSalary}
                                      onChange={(e) => setDeductFromSalary(e.target.checked)}
                                      color="primary"
                                    />
                                  }
                                  label=""
                                  sx={{ marginLeft: 0 }}
                                />
                              </FormControl>
                            </TableCell>
                            <TableCell>
                              <Autocomplete
                                options={componentCategoryOptions}
                                getOptionLabel={(option) => option.label}
                                value={
                                  componentCategoryOptions.find(
                                    (option) => option.value === componentCategory
                                  ) || null
                                }
                                onChange={(event, value) =>
                                  setComponentCategory(value ? value.value : "")
                                }
                                fullWidth
                                PaperComponent={CustomPaper}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label=""
                                    required
                                    sx={{
                                      height: 43,
                                      ...MInput.b,
                                      "& .MuiInputBase-root": {
                                        height: "100%",
                                      },
                                    }}
                                    InputLabelProps={{
                                      sx: {
                                        color: MInput.a,
                                        "&.Mui-focused": {
                                          color: "red",
                                        },
                                      },
                                    }}
                                  />
                                )}
                              />
                            </TableCell>
                            <TableCell
                              sx={{
                                position: "sticky",
                                right: 0,
                                background: "#f8f8f8",
                                zIndex: 2,
                              }}
                            >
                              <ViewButton
                                type="button"
                                onClick={handleAddStructure}
                                sx={{ minWidth: "40px" }}
                              >
                                <AddTaskIcon />
                              </ViewButton>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>

                    <TableContainer
                      sx={{
                        mt: 2,
                        width: "100%",
                        overflow: "auto",
                        height: "30vw",
                        minHeight: "150px",
                        maxHeight: "250px",
                        flexGrow: 1,
                      }}
                    >
                      <Table
                        sx={{
                          border: "1px solid #ddd",
                          borderRadius: "8px",
                          minWidth: "1100px", // Increased width for new columns
                          tableLayout: "fixed",
                        }}
                      >
                        <TableBody>
                          <TableRow
                            sx={{
                              backgroundColor: "#f0f0f0",
                            }}
                          >
                            {[
                              "Select Structure Type",
                              "Structure Name",
                              "Percent/Fixed",
                              "Applied On",
                              "Value",
                              "Deduct From Salary",
                              "Component Category",
                              "Action",
                            ].map((header, index) => (
                              <CustomTableCell
                                key={index}
                                sx={{
                                  minWidth: index === 0 ? 200 : 100,
                                  fontWeight: "bold",
                                  backgroundColor: "#f8f8f8",
                                  padding: "8px",
                                  position: index === 6 ? "sticky" : "static", // Fix last column
                                  right: index === 6 ? 0 : "auto", // Fix position on the right
                                  background: "#f8f8f8", // Ensure background for sticky column
                                  zIndex: index === 6 ? 2 : 1,
                                }}
                              >
                                {header}
                              </CustomTableCell>
                            ))}
                          </TableRow>
                          {structureData.length > 0 ? (
                            structureData.map((item, index) => (
                              <TableRow key={index}>
                                <CustomTableCell sx={{ minWidth: 200 }}>
                                  {item.structType}
                                </CustomTableCell>
                                <CustomTableCell sx={{ minWidth: 200 }}>
                                  {item.structName}
                                </CustomTableCell>
                                <CustomTableCell sx={{ minWidth: 200 }}>
                                  {item.structPercentFixedType}
                                </CustomTableCell>
                                <CustomTableCell sx={{ minWidth: 200 }}>
                                  {item.appliedOn}
                                </CustomTableCell>
                                <CustomTableCell sx={{ minWidth: 200 }}>
                                  {item.structValue}
                                </CustomTableCell>
                                <CustomTableCell sx={{ minWidth: 200 }}>
                                  {item.deductFromSalary || "N"}
                                </CustomTableCell>
                                <CustomTableCell sx={{ minWidth: 200 }}>
                                  {item.componentCategory || "-"}
                                </CustomTableCell>
                                <CustomTableCell
                                  sx={{
                                    minWidth: 150,
                                    position: "sticky",
                                    right: 0,
                                    backgroundColor: "#f8f8f8",
                                    zIndex: 2,
                                  }}
                                >
                                  <ViewButton
                                    type="button"
                                    onClick={() => handleEditStructure(index)}
                                  >
                                    <EditIcon />
                                  </ViewButton>
                                  <DeleteButton
                                    type="button"
                                    onClick={() => handleDeleteStructure(index)}
                                  >
                                    <DeleteIcon />
                                  </DeleteButton>
                                </CustomTableCell>
                              </TableRow>
                            ))
                          ) : (
                            <TableRow>
                              <CustomTableCell
                                colSpan={7} // Updated colSpan for new columns
                                align="center"
                                sx={{ padding: "10px", fontWeight: "500" }}
                              >
                                No data available
                              </CustomTableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                </form>
              </Grid>
            </TableContainer>
          </Grid>
        </Grid>
      </StyledTableContainer>

      <StyledSnackbar
        open={open}
        autoHideDuration={5000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <StyledAlert onClose={handleClose} severity={alertType}>
          {message}
        </StyledAlert>
      </StyledSnackbar>
    </DashboardLayout>
  );
}
